import { __assign } from "tslib";
import { pxToRem, fontFamily, fontFamilySerif, typeStyles, fontSizes, fontWeights, } from '@bb-ui/styling/dist';
var entries = Object.entries(typeStyles);
var muiTypeStyles = {};
for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
    var _a = entries_1[_i], type = _a[0], style = _a[1];
    var muiStyle = style;
    if (type === 'button' || type === 'overline') {
        muiStyle.textTransform = undefined;
    }
    muiTypeStyles[type] = muiStyle;
}
export var typography = __assign(__assign(__assign({}, fontSizes), fontWeights), { pxToRem: pxToRem, fontFamily: fontFamily, fontFamilySerif: fontFamilySerif, useNextVariants: true, fontSize: 14, h1: muiTypeStyles.headingXLarge, h2: muiTypeStyles.headingLarge, h3: muiTypeStyles.headingMedium, h4: muiTypeStyles.headingDefault, h5: muiTypeStyles.headingSmall, h6: muiTypeStyles.headingXSmall, body1: muiTypeStyles.bodyDefault, body2: muiTypeStyles.bodySmall, subtitle1: muiTypeStyles.subtitle1, subtitle2: muiTypeStyles.subtitle2, button: muiTypeStyles.button, caption: muiTypeStyles.caption, overline: muiTypeStyles.overline, display1: muiTypeStyles.display1, display2: muiTypeStyles.display2 });
export default typography;
//# sourceMappingURL=typography.js.map